import styled from 'styled-components'

const Form = styled.div`
  flex: 1;
  gap: 8px;
  display: flex;
  flex-direction: column;
`

const RowForm = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
  height: 100%;
`

const ColumnForm = styled.div`
  display: flex;
  flex: 1;
  gap: 8px;
  padding: 10px;
  flex-direction: column;
`
const BottomRowForm = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`
const BottomForm = styled.div`
  display: flex;
  gap: 16px;
`
const Created = styled.span`
  font-weight: 600;
  font-size: 12px;
  color: #777777;
`
const Modified = styled.span`
  font-weight: 600;
  font-size: 12px;
  color: #41CA00;
`
const ContainerForm = styled.div`
  gap: 8px;
  display: flex;
`
const FormWrapper = styled.div`
  flex: 1;
`

export default {
  Form,
  RowForm,
  Created,
  Modified,
  ColumnForm,
  BottomForm,
  FormWrapper,
  ContainerForm,
  BottomRowForm,
}
